function MagickToolTip(el)
{
    this.init($(el));
}

MagickToolTip.prototype.init=function($el){
    this.$el=$el;
    this.$tooltip=null;
    this.$el.on("mouseenter",this.onHover.bind(this));
    this.$el.on("mouseleave",this.onLeave.bind(this));

};

MagickToolTip.prototype.onHover=function(){
    this.makeTooltip();
    this.showTooltip();
};

MagickToolTip.prototype.onLeave=function() {
    this.hideTooltip();
};

MagickToolTip.prototype.makeTooltip=function() {
    if(this.$tooltip===null)
    {
        this.$tooltip=$('<div class="magick-tooltip"><img src=""/></div>');
        var offset=this.$el.offset();
        this.$tooltip.css({opacity:0,left:offset.left+"px",top:offset.top+"px"});
        $("body").append(this.$tooltip);
    }else{
        this.$tooltip.stop(true);
    }
};

MagickToolTip.prototype.showTooltip=function() {
    this.$tooltip.animate({opacity:1},500);
};

MagickToolTip.prototype.hideTooltip=function() {
    this.$tooltip.animate({opacity:0},500,function(){
        this.$tooltip.remove();
        this.$tooltip=null;
    }.bind(this));
};

$(function(){
    $(".help-section").each(function(i,el) {
        new MagickToolTip(el);
    });
});